import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=2d6ec942"
import script from "./ContentItem.vue?vue&type=script&lang=ts"
export * from "./ContentItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports